import { createPaymentElementWebComponent } from './createWebComponent';

/**
 * Create the Payment Element Web Component class.
 * This version does NOT auto-register with customElements.
 * Users should manually register with their preferred tag name.
 */
export const PaymentElementWebComponent = createPaymentElementWebComponent();
